import { useAuthStore } from '../stores/authStore';

/** Thin subscription to authStore.isSessionExpired — shared gate for all query hooks. */
export function useSessionGate(): { expired: boolean } {
  const expired = useAuthStore(state => state.isSessionExpired);
  return { expired };
}
